export const phoneIsValid = (phone: string) => {
  phone = phone.replace(/\D/g, '');

  if (!(phone.length >= 10 && phone.length <= 11)) return false;
  if (phone.length == 10 && parseInt(phone.substring(2, 3)) === 9) return false;
  if (phone.length == 11 && parseInt(phone.substring(2, 3)) !== 9) return false;

  return true;
}
